import '../assets/NcRichText-DNXuHl34.css';
import { N as _, L as b } from "./referencePickerModal-AvSHyw1b.mjs";
import { U as p, p as y, r as w, g as R } from "./autolink-DNGB8YSW.mjs";
import f from "@nextcloud/axios";
import { generateOcsUrl as h } from "@nextcloud/router";
/* empty css                                                                     */
import { n as g } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { N } from "./NcCheckboxRadioSwitch-BOl1O2zi.mjs";
import { visit as M } from "unist-util-visit";
import { u as m } from "unist-builder";
import { G as x } from "./GenRandomId-BW3iYFf9.mjs";
import { unified as $ } from "unified";
import I from "remark-parse";
import E from "remark-gfm";
import O from "remark-breaks";
import L from "remark-rehype";
import j from "rehype-react";
import B from "rehype-external-links";
const C = {
  name: "NcReferenceList",
  components: {
    NcReferenceWidget: _
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    referenceData: {
      type: Object,
      default: null
    },
    limit: {
      type: Number,
      default: 1
    },
    displayFallback: {
      type: Boolean,
      default: !1
    },
    interactive: {
      type: Boolean,
      default: !0
    },
    interactiveOptIn: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      references: null,
      loading: !0
    };
  },
  computed: {
    isVisible() {
      return this.loading || this.displayedReferences.length !== 0;
    },
    values() {
      return this.referenceData ? this.referenceData : this.displayFallback && !this.loading && !this.references ? [this.fallbackReference] : this.references ? Object.values(this.references) : [];
    },
    firstReference() {
      var e;
      return (e = this.values[0]) != null ? e : null;
    },
    displayedReferences() {
      return this.values.slice(0, this.limit);
    },
    fallbackReference() {
      return {
        accessible: !0,
        openGraphObject: {
          id: this.text,
          link: this.text,
          name: this.text
        },
        richObjectType: "open-graph"
      };
    }
  },
  watch: {
    text: "fetch"
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      if (this.loading = !0, this.referenceData) {
        this.loading = !1;
        return;
      }
      if (!new RegExp(p).exec(this.text)) {
        this.loading = !1;
        return;
      }
      this.resolve().then((e) => {
        this.references = e.data.ocs.data.references, this.loading = !1, this.$emit("loaded");
      }).catch((e) => {
        console.error("Failed to extract references", e), this.loading = !1, this.$emit("loaded");
      });
    },
    resolve() {
      const e = new RegExp(p).exec(this.text.trim());
      return this.limit === 1 && e ? f.get(h("references/resolve", 2) + "?reference=".concat(encodeURIComponent(e[0]))) : f.post(h("references/extract", 2), {
        text: this.text,
        resolve: !0,
        limit: this.limit
      });
    }
  }
};
var A = function() {
  var i = this, r = i._self._c;
  return i.isVisible ? r("div", { staticClass: "widgets--list", class: { "icon-loading": i.loading } }, i._l(i.displayedReferences, function(t) {
    var n;
    return r("div", { key: (n = t == null ? void 0 : t.openGraphObject) == null ? void 0 : n.id }, [r("NcReferenceWidget", { attrs: { reference: t, interactive: i.interactive, "interactive-opt-in": i.interactiveOptIn } })], 1);
  }), 0) : i._e();
}, D = [], P = /* @__PURE__ */ g(
  C,
  A,
  D,
  !1,
  null,
  "84219a41",
  null,
  null
);
const u = P.exports, T = function() {
  return function(e) {
    M(e, (r) => r.type === "text", i);
    function i(r, t, n) {
      const a = r.value.split(/(\{[a-z\-_.0-9]+\})/ig).map((s, d, o) => {
        const c = s.match(/^\{([a-z\-_.0-9]+)\}$/i);
        if (!c)
          return m("text", s);
        const [, l] = c;
        return m("element", {
          tagName: "#".concat(l)
        });
      });
      n.children.splice(t, 1, ...a);
    }
  };
}, z = ({ h: e, context: i }, r) => (i.autolink && (r = y(r)), Array.isArray(r) ? r.map((t) => {
  if (typeof t == "string")
    return t;
  const { component: n, props: a } = t, s = n.name === "NcLink" ? void 0 : "rich-text--component";
  return e(n, {
    props: a,
    class: s
  });
}) : r), F = {
  name: "NcRichText",
  components: {
    NcReferenceList: u
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    arguments: {
      type: Object,
      default: () => ({})
    },
    referenceLimit: {
      type: Number,
      default: 0
    },
    referenceInteractive: {
      type: Boolean,
      default: !0
    },
    /** Provide data upfront to avoid extra http request */
    references: {
      type: Object,
      default: null
    },
    markdownCssClasses: {
      type: Object,
      default: () => ({
        a: "rich-text--external-link",
        ol: "rich-text--ordered-list",
        ul: "rich-text--un-ordered-list",
        li: "rich-text--list-item",
        strong: "rich-text--strong",
        em: "rich-text--italic",
        h1: "rich-text--heading rich-text--heading-1",
        h2: "rich-text--heading rich-text--heading-2",
        h3: "rich-text--heading rich-text--heading-3",
        h4: "rich-text--heading rich-text--heading-4",
        h5: "rich-text--heading rich-text--heading-5",
        h6: "rich-text--heading rich-text--heading-6",
        hr: "rich-text--hr",
        table: "rich-text--table",
        pre: "rich-text--pre",
        code: "rich-text--code",
        blockquote: "rich-text--blockquote"
      })
    },
    useMarkdown: {
      type: Boolean,
      default: !1
    },
    /** Provide GitHub Flavored Markdown syntax */
    useExtendedMarkdown: {
      type: Boolean,
      default: !1
    },
    /** Provide event from rendered markdown inputs */
    interactive: {
      type: Boolean,
      default: !1
    },
    autolink: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["interact:todo"],
  data() {
    return {
      parentId: x(5)
    };
  },
  methods: {
    renderPlaintext(e) {
      const i = this, r = this.text.split(/(\{[a-z\-_.0-9]+\})/ig).map(function(t, n, a) {
        const s = t.match(/^\{([a-z\-_.0-9]+)\}$/i);
        if (!s)
          return z({ h: e, context: i }, t);
        const d = s[1], o = i.arguments[d];
        if (typeof o == "object") {
          const { component: c, props: l } = o;
          return e(c, {
            props: l,
            class: "rich-text--component"
          });
        }
        return o ? e("span", { class: "rich-text--fallback" }, o) : t;
      });
      return e("div", { class: "rich-text--wrapper" }, [
        e("div", {}, r.flat()),
        this.referenceLimit > 0 ? e("div", { class: "rich-text--reference-widget" }, [
          e(u, {
            props: {
              text: this.text,
              referenceData: this.references,
              interactive: this.referenceInteractive
            }
          })
        ]) : null
      ]);
    },
    renderMarkdown(e) {
      const i = $().use(I).use(w, {
        autolink: this.autolink,
        useMarkdown: this.useMarkdown,
        useExtendedMarkdown: this.useExtendedMarkdown
      }).use(this.useExtendedMarkdown ? E : void 0).use(O).use(L, {
        handlers: {
          component(r, t) {
            return r(t, t.component, { value: t.value });
          }
        }
      }).use(T).use(B, {
        target: "_blank",
        rel: ["noopener noreferrer"]
      }).use(j, {
        createElement: (r, t, n) => {
          if (n = n == null ? void 0 : n.map(
            (s) => typeof s == "string" ? s.replace(/&lt;/gmi, "<") : s
          ), !r.startsWith("#")) {
            if (this.useExtendedMarkdown) {
              let s = null;
              if (r === "li" && Array.isArray(n) && n[0].tag === "input" && n[0].data.attrs.type === "checkbox") {
                const [d, ...o] = n, c = o.findIndex((v) => ["ul", "ol", "li", "blockquote", "pre"].includes(v.tag));
                c !== -1 && (s = o[c], o.splice(c));
                const l = this.parentId + "-markdown-input-" + x(5), k = e(N, {
                  attrs: {
                    ...d.data.attrs,
                    id: l,
                    disabled: !this.interactive
                  },
                  on: {
                    "update:checked": () => {
                      this.$emit("interact:todo", l);
                    }
                  }
                }, o);
                return e(r, t, [k, s]);
              }
            }
            if (r === "a") {
              const s = R(this.$router, t.attrs.href);
              if (s)
                return delete t.attrs.href, delete t.attrs.target, e(b, {
                  ...t,
                  props: {
                    to: s
                  }
                }, n);
            }
            return e(r, t, n);
          }
          const a = this.arguments[r.slice(1)];
          return a ? a.component ? e(
            a.component,
            {
              attrs: t,
              props: a.props,
              class: "rich-text--component"
            },
            n
          ) : e("span", t, [a]) : e("span", { attrs: t, class: "rich-text--fallback" }, ["{".concat(r.slice(1), "}")]);
        },
        prefix: !1
      }).processSync(
        this.text.replace(/</gmi, "&lt;").replace(/&gt;/gmi, ">")
      ).result;
      return e("div", { class: "rich-text--wrapper rich-text--wrapper-markdown" }, [
        i,
        this.referenceLimit > 0 ? e("div", { class: "rich-text--reference-widget" }, [
          e(u, {
            props: {
              text: this.text,
              referenceData: this.references,
              interactive: this.referenceInteractive
            }
          })
        ]) : null
      ]);
    }
  },
  render(e) {
    return this.useMarkdown || this.useExtendedMarkdown ? this.renderMarkdown(e) : this.renderPlaintext(e);
  }
}, G = null, U = null;
var S = /* @__PURE__ */ g(
  F,
  G,
  U,
  !1,
  null,
  "95ce8ae1",
  null,
  null
);
const oe = S.exports;
export {
  oe as N,
  u as a
};
